import React from 'react';
import {
  CapabilityCard,
  CapabilityCardPortalPreview
} from '@thd-olt-component-react/capability_card';

const xlSlides = (slides, isPortalLivePreview = false, enableB2CRadius = false) => slides?.map((group, groupKey) => (
  <div className="sui-flex sui-w-full sui-gap-y-4 sui-flex-col" key={groupKey}>
    {group?.map((card, cardKey) => {
      const cardId = card.id || card.sys?.id || `capability-card-${cardKey}`;

      return (
        <div className="capability_card" key={cardKey + cardId}>
          {isPortalLivePreview
            ? (
              <CapabilityCardPortalPreview
                componentId={cardId}
                componentClass="CapabilityCard"
                portalPreviewData={card}
                isHorizontal
              />
            ) : (
              <CapabilityCard
                headline={card.headline}
                richText={typeof card.richTextContent === 'string'
                  ? card.richTextContent
                  : JSON.stringify(card.richTextContent?.json)}
                componentPosition={cardKey + 1}
                componentId={cardId}
                enableB2CRadius={enableB2CRadius}
              />
            )}
        </div>
      );
    })}
  </div>
)
);

export default xlSlides;
